import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { FormattedMessage } from 'react-intl';
import PATHS from 'constants/paths';

const GuestNotStrict = ({ url }) => {
  return (
    <Box>
      <Typography paragraph>
        <FormattedMessage
          id="bookingInfo.youHaveToComplete"
          defaultMessage="You have to complete your profile before you can accept and pay for this booking"
        />

      </Typography>
      <Button
        variant="contained"
        color="primary"
        component={Link}
        size="small"
        to={`${PATHS.users.profile}?next=${url}&booking=true`}
        style={{ marginBottom: '10px' }}
      >
        <FormattedMessage
          id="cottages.clickHereToAdd"
          defaultMessage="Click here to complete your profile"
        />
      </Button>
    </Box>
  );
};

GuestNotStrict.propTypes = {
  url: PropTypes.string.isRequired,
};

export default GuestNotStrict;
